import { GenericAccordion, FieldRow } from '../SettingsUI';
import type { FieldSetting } from '../../types';

const FIELDS = [
  { label: 'Biography', key: 'bio' },
  { label: 'Profile Photo', key: 'headshot' },
  { label: 'DOB', key: 'dob' },
  { label: 'Country', key: 'country' }
];

interface DemographicPanelProps {
  fieldSettings: Record<string, FieldSetting>;
  updateField: (
    key: string,
    role: 'mentee' | 'mentor' | 'admin' | 'mandatory',
    value: boolean
  ) => void;
}

export function DemographicPanel({ fieldSettings, updateField }: DemographicPanelProps) {
  return (
    <GenericAccordion title="Demographic">
      {FIELDS.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
          onMandatoryChange={(val) => updateField(key, 'mandatory', val)}
        />
      ))}
    </GenericAccordion>
  );
}
